function getFullPageCalendarPath(categorySlug: string, subcategorySlug: string | undefined, productSlug: string) {
    const subcategoryPathSegment = subcategorySlug ? `/${subcategorySlug}` : ''
    return `/l/${categorySlug}${subcategoryPathSegment}/c/${productSlug}`
}

function getPDPPath(categorySlug: string, subcategorySlug: string | undefined, productSlug: string) {
    const subcategoryPathSegment = subcategorySlug ? `/${subcategorySlug}` : ''
    return `/l/${categorySlug}${subcategoryPathSegment}/p/${productSlug}`
}

function getCategoryPath(categorySlug: string, subcategorySlug: string | undefined) {
    const subcategoryPathSegment = subcategorySlug ? `/${subcategorySlug}` : ''
    return `/l/${categorySlug}${subcategoryPathSegment}`
}

export const publicUIPathGetters = {
    getFullPageCalendarPath,
    getPDPPath,
    getCategoryPath,
}